import { all, call, takeEvery, fork } from "redux-saga/effects";
import { fetchSkillSelectSuccess } from "../Actions";
import { FETCH_SKILL_SELECT } from "../ActionTypes";
import { getAllSkillSelect } from "../Api";
import requestFunction from "../Utils/SagaGenericFunction";

// =================FETCH Skill Select sagas================
const fetchSkillSelectRequest = function* ({ payload }) {
    yield call(requestFunction, fetchSkillSelectSuccess, getAllSkillSelect, payload);
  };
  
  export const fetchTheSkillSelect = function* () {
    yield takeEvery(FETCH_SKILL_SELECT, fetchSkillSelectRequest);
  };


  export default function* rootSaga() {
    yield all([fork(fetchTheSkillSelect)]);
  }